export const getters = {
  films(state) {
    return state.films
  },
  film (state) {
    return state.film
  },  
  pagination(state){
    return state.pagination
  }
}
